import type { ThemeType } from '@uipath/portal-shell-util';
import { setUserTheme } from '@uipath/portal-shell-util';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import useUserInfo from '../../auth/hooks/UserInfo';
import {
    accountGlobalId,
    userGlobalId,
} from '../../store/selectors';
import { getOrganizationStandardUrl } from '../../util/UrlUtil.default';

const useSetUserTheme = () => {
    const { token } = useUserInfo();
    const partitionGlobalId = useSelector(accountGlobalId);
    const userId = useSelector(userGlobalId);
    return useCallback(async (theme: ThemeType) => {
        await setUserTheme(theme, getOrganizationStandardUrl(), token, partitionGlobalId, userId);
    }, [ partitionGlobalId, token, userId ]);
};

export default useSetUserTheme;
